import PropTypes from "prop-types";
import { useCallback, useContext, useMemo } from "react";

import { withALErrorBoundary } from "../../../helpers/ErrorBoundary/ALErrorBoundary";
import { CartContext } from "../../../context/CartProvider";
import useDiscountsInfo from "@hooks/useDiscountsInfo";

import { GIFT_PACKAGES_HANDLES } from "@constants/GiftPackages";
import DISCOUNT_TYPES from "@constants/DiscountTypes";

import IconAdd from "@svgs/add.svg";
import IconMinus from "@svgs/minus.svg";

function Actions({ lineItem, isFreeGift, onRemove, onSwapGift }) {
  const { addSingleProductToCart: addProductToCart } = useContext(CartContext);
  const discountsInfo = useDiscountsInfo();
  const giftDiscount =
    (discountsInfo || []).find((s) => s.type === DISCOUNT_TYPES.GIFT_WITH_PURCHASE) || null;
  const freeGiftProducts = useMemo(() => giftDiscount?.freegift?.products || [], [giftDiscount]);

  const isGiftPackage = lineItem && GIFT_PACKAGES_HANDLES.includes(lineItem.variant.product.handle);

  const onUpdateQuantity = useCallback(
    (qty) => {
      const { variant } = lineItem;
      const dataProductToAdd = {
        id: lineItem.id,
        quantity: qty,
        attributes: lineItem.attributes,
        variant: {
          id: variant.id,
          sku: variant.sku,
          price: variant.price?.amount,
          compareAtPrice: variant.compareAtPrice,
          product: {
            title: variant.title,
            id: variant.id,
            images: [variant.image],
          },
        },
      };

      addProductToCart({ dataProductToAdd });
    },
    [addProductToCart, lineItem]
  );
  const onClickAdd = useCallback(() => {
    onUpdateQuantity(lineItem.quantity + 1);
  }, [lineItem, onUpdateQuantity]);
  const onClickMinus = useCallback(() => {
    if (lineItem.quantity > 1) {
      onUpdateQuantity(lineItem.quantity - 1);
    } else {
      onRemove(lineItem.id);
    }
  }, [lineItem.id, lineItem.quantity, onRemove, onUpdateQuantity]);

  if (isFreeGift && freeGiftProducts.length > 1) {
    return (
      <button
        type="button"
        onClick={onSwapGift}
        className="font-bold typo-body mobile:typo-micro underline text-right"
      >
        Swap Gift
      </button>
    );
  }

  if (isFreeGift || isGiftPackage) {
    return null;
  }

  return (
    <div className="flex border border-primary justify-between items-center w-fit rounded-[4px]">
      <button className="py-[5px] px-[10px] cursor-pointer" type="button" onClick={onClickMinus}>
        <IconMinus width="10" height="10" stroke="#000000" />
      </button>
      <div className="py-[5px] px-[8px] typo-body">{lineItem.quantity}</div>
      <button className="py-[5px] px-[10px] cursor-pointer" type="button" onClick={onClickAdd}>
        <IconAdd width="10" height="10" fill="#000000" />
      </button>
    </div>
  );
}

Actions.propTypes = {
  lineItem: PropTypes.shape({
    id: PropTypes.string.isRequired,
    quantity: PropTypes.number.isRequired,
    attributes: PropTypes.arrayOf(
      PropTypes.shape({
        key: PropTypes.string.isRequired,
        value: PropTypes.string.isRequired,
      })
    ).isRequired,
  }),
  isFreeGift: PropTypes.bool,
  onRemove: PropTypes.func,
  onSwapGift: PropTypes.func,
};

export default withALErrorBoundary({
  name: "Actions",
  priority: "P2",
})(Actions);
